import api from "./services/mkm.api.js"

const resource = "/fortbildungsgruppe"

export default{
    alle() {
        return api.get(`${resource}`);
    }
}